/* eslint-disable no-unused-vars */
import { PPI } from "@/box/constants.js"

function getSvgForGeom(box) {
  const svgWidth = box.getDocumentWidth();
  const svgHeight = box.getDocumentHeight();

  let svg = `
          <svg
          xmlns="http://www.w3.org/2000/svg"
          width="${svgWidth}"
          height="${svgHeight}"
          viewBox="0 0 ${svgWidth} ${svgHeight}"
          stroke="blue"
          stroke-width="0.01" >
          `;

  box.panels.forEach((panel) => {
    svg += `<path fill="none" data-panelName="${panel.name} ${panel.row}Row" data-panelWidth="${panel.width}" data-panelHeight="${panel.height}" d="${panel.path}"/>`;
  })

  svg += "</svg>";

  return svg;
}

function get2DEditorSvg(box, printSide = "outside") {
  const documentWidth = box.canvasWidth
  const documentHeight = box.canvasHeight

  const largerDocumentDimension = documentWidth > documentHeight ? documentWidth : documentHeight
  const strokeWidth = largerDocumentDimension / 3000

  let svg = `
    <svg width="${documentWidth}" height="${documentHeight}" viewBox="0 0 ${documentWidth} ${documentHeight}" stroke-width="${strokeWidth}" xmlns="http://www.w3.org/2000/svg" version="1.1">
  `

  svg += getOutline(box, printSide)

  svg += getCutlines(box, printSide)

  svg += `</svg>`;
  return svg
}

function createPathDefinitionForOutlineWithBleed(box, isNormalized = false) {
  const documentWidth = box.canvasWidth
  const documentHeight = box.canvasHeight

  // Normalizes x between 0 and 1 or return raw x value depending on isNormalized
  // This way if svg viewbox is not set to 1 1 the values represent percentages
  function adjustedX(x) {
    return isNormalized ? x / documentWidth: x;
  }

  // Normalizes y between 0 and 1 or return raw x value depending on isNormalized
  // This way if svg viewbox is not set to 1 1 the values represent percentages
  function adjustedY(y) {
    return isNormalized ? y / documentHeight : y;
  }

  const B = box.bleedInPx
  const MT = box.materialThicknessInPx
  const D = box.depthInPx
  const OW = box.overlapWidthInPx
  const COW = box.cutOutWidthInPx

  const panels = box.panels.map(panel => ({
    ...panel,
    left: panel.left * PPI,
    top: panel.top * PPI,
    width: panel.width * PPI,
    height: panel.height * PPI
  }))

  const frontRightFlap = panels.find(panel => panel.name === "frontRightFlap")

  const rightClosingFlap = panels.find(panel => panel.name === "rightClosingFlap")
  // @TODO: Do this better on both PIZZA box and MAILER box TUCK IN
  rightClosingFlap.point7.x *= PPI
  rightClosingFlap.point7.y *= PPI

  const leftClosingFlap = panels.find(panel => panel.name === "leftClosingFlap")
  // @TODO: Do this better on both PIZZA box and MAILER box TUCK IN
  leftClosingFlap.point3.x *= PPI
  leftClosingFlap.point3.y *= PPI

  const frontClosingFlap = panels.find(panel => panel.name === "frontClosingFlap")
  frontClosingFlap.point5.x *= PPI
  frontClosingFlap.point5.y *= PPI
  frontClosingFlap.point12.x *= PPI
  frontClosingFlap.point12.y *= PPI

  const d = `
    M ${adjustedX(0)} ${adjustedY(0)}
    L ${adjustedX(frontRightFlap.left + frontRightFlap.width + B)} ${adjustedY(0)}
    L ${adjustedX(frontRightFlap.left + frontRightFlap.width + B)} ${adjustedY(rightClosingFlap.top + 0.25*rightClosingFlap.height + B)}
    L ${adjustedX(frontRightFlap.left + frontRightFlap.width - COW + B)} ${adjustedY(rightClosingFlap.top + 0.25*rightClosingFlap.height + B)}
    L ${adjustedX(frontRightFlap.left + frontRightFlap.width - COW + B)} ${adjustedY(rightClosingFlap.top + 0.75*rightClosingFlap.height - B)}
    L ${adjustedX(frontRightFlap.left + frontRightFlap.width + B)} ${adjustedY(rightClosingFlap.top + 0.75*rightClosingFlap.height - B)}
    L ${adjustedX(frontRightFlap.left + frontRightFlap.width + B)} ${adjustedY(rightClosingFlap.point7.y - (1 * PPI))}
    Q ${adjustedX(rightClosingFlap.point7.x + (1 * PPI) + B)} ${adjustedY(rightClosingFlap.point7.y - 0.25)} ${adjustedX(rightClosingFlap.point7.x + B)} ${adjustedY(rightClosingFlap.point7.y + B)}
    L ${adjustedX(rightClosingFlap.left + B)} ${adjustedY(rightClosingFlap.top + rightClosingFlap.height + B)}
    L ${adjustedX(frontClosingFlap.point5.x + B)} ${adjustedY(frontClosingFlap.point5.y)}
    Q ${adjustedX(frontClosingFlap.point5.x - (0.25 * PPI) + B)} ${adjustedY(frontClosingFlap.point5.y + (1 * PPI) + B)} ${adjustedX(frontClosingFlap.point5.x - (1 * PPI))} ${adjustedY(frontClosingFlap.top + frontClosingFlap.height + B)}
    L ${adjustedX(frontClosingFlap.left + frontClosingFlap.width * 0.75 - B)} ${adjustedY(frontClosingFlap.top + frontClosingFlap.height + B)}
    L ${adjustedX(frontClosingFlap.left + frontClosingFlap.width * 0.75 - B)} ${adjustedY(frontClosingFlap.top + frontClosingFlap.height - COW + B)}
    L ${adjustedX(frontClosingFlap.left + frontClosingFlap.width * 0.25 + B)} ${adjustedY(frontClosingFlap.top + frontClosingFlap.height - COW + B)}
    L ${adjustedX(frontClosingFlap.left + frontClosingFlap.width * 0.25 + B)} ${adjustedY(frontClosingFlap.top + frontClosingFlap.height + B)}
    L ${adjustedX(frontClosingFlap.point12.x + (1 * PPI))} ${adjustedY(frontClosingFlap.top + frontClosingFlap.height + B)}
    Q ${adjustedX(frontClosingFlap.point12.x + (0.25 * PPI) - B)} ${adjustedY(frontClosingFlap.point12.y + (1 * PPI) + B)} ${adjustedX(frontClosingFlap.point12.x - B)} ${adjustedY(frontClosingFlap.point12.y)}
    L ${adjustedX(frontClosingFlap.left - B)} ${adjustedY(frontClosingFlap.top + B)}
    L ${adjustedX(leftClosingFlap.point3.x)} ${adjustedY(leftClosingFlap.point3.y + B)}
    Q ${adjustedX(leftClosingFlap.point3.x - (1 * PPI) - B)} ${adjustedY(leftClosingFlap.point3.y + B - (0.25 * PPI))} ${adjustedX(0)} ${adjustedY(leftClosingFlap.point3.y - (1 * PPI))}
    L ${adjustedX(leftClosingFlap.left - B)} ${adjustedY(leftClosingFlap.top + 0.75*leftClosingFlap.height - B)}
    L ${adjustedX(leftClosingFlap.left + COW - B)} ${adjustedY(leftClosingFlap.top + 0.75*leftClosingFlap.height - B)}
    L ${adjustedX(leftClosingFlap.left + COW - B)} ${adjustedY(leftClosingFlap.top + 0.25*leftClosingFlap.height + B)}
    L ${adjustedX(leftClosingFlap.left - B)} ${adjustedY(leftClosingFlap.top + 0.25*leftClosingFlap.height + B)}
    L ${adjustedX(0)} ${adjustedY(0)}
    Z
  `

  return d
}

function getOutlineWithBleed(box, isNormalized = false, printSide = 'outside') {
  const transformElement = printSide === 'inside' ? `transform: scaleX(-1) translateX(-1px);` : ''

  const path = `
    <path
      style="${transformElement}"
      stroke="green"
      fill="#000000"
      d="${createPathDefinitionForOutlineWithBleed(box, isNormalized)}"
    />
  `
  return path
}

function createPathDefinitionForOutlineWithoutNonPrintPanels(box, isNormalized = false) {
  const documentWidth = box.canvasWidth
  const documentHeight = box.canvasHeight

  // Normalizes x between 0 and 1 or return raw x value depending on isNormalized
  // This way if svg viewbox is not set to 1 1 the values represent percentages
  function adjustedX(x) {
    return isNormalized ? x / documentWidth: x;
  }

  // Normalizes y between 0 and 1 or return raw x value depending on isNormalized
  // This way if svg viewbox is not set to 1 1 the values represent percentages
  function adjustedY(y) {
    return isNormalized ? y / documentHeight : y;
  }

  const B = box.bleedInPx
  const MT = box.materialThicknessInPx
  const OW = box.overlapWidthInPx

  const panels = box.panels.map(panel => ({
    ...panel,
    left: panel.left * PPI,
    top: panel.top * PPI,
    width: panel.width * PPI,
    height: panel.height * PPI
  }))

  const overlap = panels.find(panel => panel.name === "overlap")
  const outsideFrontWall = panels.find(panel => panel.name === "outsideFrontWall")
  const bottom = panels.find(panel => panel.name === "bottom")
  const rightOutsideWall = panels.find(panel => panel.name === "rightOutsideWall")
  const leftOutsideWall = panels.find(panel => panel.name === "leftOutsideWall")
  const backRightFlap = panels.find(panel => panel.name === "backRightFlap")
  const backLeftFlap = panels.find(panel => panel.name === "backLeftFlap")
  const leftClosingFlap = panels.find(panel => panel.name === "leftClosingFlap")
  const rightClosingFlap = panels.find(panel => panel.name === "rightClosingFlap")
  const top = panels.find(panel => panel.name === "top")

  const d = `
    M ${adjustedX(overlap.left + 2*MT - B)} ${adjustedY(overlap.top - B)}
    L ${adjustedX(overlap.left + overlap.width - 2*MT + B)} ${adjustedY(overlap.top - B)}
    L ${adjustedX(overlap.left + overlap.width - 2*MT + B)} ${adjustedY(overlap.top)}
    L ${adjustedX(overlap.left + overlap.width + B)} ${adjustedY(overlap.top + overlap.height)}
    L ${adjustedX(overlap.left + overlap.width + B)} ${adjustedY(outsideFrontWall.top + outsideFrontWall.height)}
    L ${adjustedX(bottom.left + bottom.width + B)} ${adjustedY(bottom.top)}
    L ${adjustedX(bottom.left + bottom.width - MT + B)} ${adjustedY(rightOutsideWall.top - B)}
    L ${adjustedX(rightOutsideWall.left + rightOutsideWall.width + B)} ${adjustedY(rightOutsideWall.top - B)}
    L ${adjustedX(rightOutsideWall.left + rightOutsideWall.width + B)} ${adjustedY(rightOutsideWall.top + rightOutsideWall.height + B)}
    L ${adjustedX(backRightFlap.left + 2*MT + B)} ${adjustedY(backRightFlap.top + B)}
    L ${adjustedX(backRightFlap.left + 2*MT + B)} ${adjustedY(backRightFlap.top + 2*MT + B)}
    L ${adjustedX(backRightFlap.left + 2*MT + B)} ${adjustedY(backRightFlap.top + backRightFlap.height - 2*MT)}
    L ${adjustedX(backRightFlap.left + B)} ${adjustedY(rightClosingFlap.top)}
    L ${adjustedX(backRightFlap.left + B)} ${adjustedY(top.top + top.height - (0.5 * PPI) + B)}
    L ${adjustedX(top.left + 0.5*top.width + (0.5 * PPI) + B)} ${adjustedY(top.top + top.height - (0.5 * PPI) + B)}
    Q ${adjustedX(top.left + top.width / 2 + (0.5 * PPI) + B)} ${adjustedY(top.top + top.height + B)} ${adjustedX(top.left + 0.5*top.width)} ${adjustedY(top.top + top.height + B)}
    Q ${adjustedX(top.left + top.width / 2 - (0.5 * PPI) - B)} ${adjustedY(top.top + top.height + B)} ${adjustedX(top.left + 0.5*top.width - (0.5 * PPI) - B)} ${adjustedY(top.top + top.height - (0.5 * PPI) + B)}
    L ${adjustedX(top.left - B)} ${adjustedY(top.top + top.height - (0.5 * PPI) + B)}
    L ${adjustedX(leftClosingFlap.left + leftClosingFlap.width - B)} ${adjustedY(leftClosingFlap.top)}
    L ${adjustedX(backLeftFlap.left + backLeftFlap.width - 2*MT - B)} ${adjustedY(backLeftFlap.top + backLeftFlap.height - 2*MT)}
    L ${adjustedX(backLeftFlap.left + backLeftFlap.width - 2*MT - B)} ${adjustedY(backLeftFlap.top + B)}
    L ${adjustedX(leftOutsideWall.left - B)} ${adjustedY(backLeftFlap.top + B)}
    L ${adjustedX(leftOutsideWall.left - B)} ${adjustedY(leftOutsideWall.top - B)}
    L ${adjustedX(outsideFrontWall.left - B)} ${adjustedY(leftOutsideWall.top - B)}
    L ${adjustedX(outsideFrontWall.left - B)} ${adjustedY(overlap.top + overlap.height)}
    L ${adjustedX(overlap.left + 2*MT - B)} ${adjustedY(overlap.top)}
    L ${adjustedX(overlap.left + 2*MT - B)} ${adjustedY(overlap.top - B)}
    Z
  `
  return d
}

function createPathDefinitionForOutlineWithoutNonPrintPanelsForInsidePrint(box, isNormalized = false) {
  const documentWidth = box.canvasWidth
  const documentHeight = box.canvasHeight

  // Normalizes x between 0 and 1 or return raw x value depending on isNormalized
  // This way if svg viewbox is not set to 1 1 the values represent percentages
  function adjustedX(x) {
    return isNormalized ? x / documentWidth: x;
  }

  // Normalizes y between 0 and 1 or return raw x value depending on isNormalized
  // This way if svg viewbox is not set to 1 1 the values represent percentages
  function adjustedY(y) {
    return isNormalized ? y / documentHeight : y;
  }

  const B = box.bleedInPx
  const MT = box.materialThicknessInPx
  const OW = box.overlapWidthInPx

  const panels = box.panels.map(panel => ({
    ...panel,
    left: panel.left * PPI,
    top: panel.top * PPI,
    width: panel.width * PPI,
    height: panel.height * PPI
  }))

  const overlap = panels.find(panel => panel.name === "overlap")
  const outsideFrontWall = panels.find(panel => panel.name === "outsideFrontWall")
  const bottom = panels.find(panel => panel.name === "bottom")
  const rightOutsideWall = panels.find(panel => panel.name === "rightOutsideWall")
  const leftOutsideWall = panels.find(panel => panel.name === "leftOutsideWall")
  const backRightFlap = panels.find(panel => panel.name === "backRightFlap")
  const backLeftFlap = panels.find(panel => panel.name === "backLeftFlap")
  const leftClosingFlap = panels.find(panel => panel.name === "leftClosingFlap")
  const rightClosingFlap = panels.find(panel => panel.name === "rightClosingFlap")
  const top = panels.find(panel => panel.name === "top")

  const d = `
    M ${adjustedX(overlap.left + 2*MT - B)} ${adjustedY(overlap.top - B)}
    L ${adjustedX(overlap.left + overlap.width - 2*MT + B)} ${adjustedY(overlap.top - B)}
    L ${adjustedX(overlap.left + overlap.width - 2*MT + B)} ${adjustedY(overlap.top)}
    L ${adjustedX(overlap.left + overlap.width + B)} ${adjustedY(overlap.top + overlap.height)}
    L ${adjustedX(overlap.left + overlap.width + B)} ${adjustedY(outsideFrontWall.top + outsideFrontWall.height)}
    L ${adjustedX(bottom.left + bottom.width + B)} ${adjustedY(bottom.top)}
    L ${adjustedX(bottom.left + bottom.width - MT + B)} ${adjustedY(rightOutsideWall.top - B)}
    L ${adjustedX(rightOutsideWall.left + rightOutsideWall.width + B)} ${adjustedY(rightOutsideWall.top - B)}
    L ${adjustedX(rightOutsideWall.left + rightOutsideWall.width + B)} ${adjustedY(rightOutsideWall.top + rightOutsideWall.height + B)}
    L ${adjustedX(backRightFlap.left + 2*MT + B)} ${adjustedY(backRightFlap.top + B)}
    L ${adjustedX(backRightFlap.left + 2*MT + B)} ${adjustedY(backRightFlap.top + 2*MT + B)}
    L ${adjustedX(backRightFlap.left + 2*MT + B)} ${adjustedY(backRightFlap.top + backRightFlap.height - 2*MT)}
    L ${adjustedX(backRightFlap.left + B)} ${adjustedY(rightClosingFlap.top)}
    L ${adjustedX(backRightFlap.left + B)} ${adjustedY(top.top + top.height - (0.5 * PPI) + B)}
    L ${adjustedX(top.left + 0.5*top.width + (0.5 * PPI) + B)} ${adjustedY(top.top + top.height - (0.5 * PPI) + B)}
    Q ${adjustedX(top.left + top.width / 2 + (0.5 * PPI) + B)} ${adjustedY(top.top + top.height + B)} ${adjustedX(top.left + 0.5*top.width)} ${adjustedY(top.top + top.height + B)}
    Q ${adjustedX(top.left + top.width / 2 - (0.5 * PPI) - B)} ${adjustedY(top.top + top.height + B)} ${adjustedX(top.left + 0.5*top.width - (0.5 * PPI) - B)} ${adjustedY(top.top + top.height - (0.5 * PPI) + B)}
    L ${adjustedX(top.left - B)} ${adjustedY(top.top + top.height - (0.5 * PPI) + B)}
    L ${adjustedX(leftClosingFlap.left + leftClosingFlap.width - B)} ${adjustedY(leftClosingFlap.top)}
    L ${adjustedX(backLeftFlap.left + backLeftFlap.width - 2*MT - B)} ${adjustedY(backLeftFlap.top + backLeftFlap.height - 2*MT)}
    L ${adjustedX(backLeftFlap.left + backLeftFlap.width - 2*MT - B)} ${adjustedY(backLeftFlap.top + B)}
    L ${adjustedX(leftOutsideWall.left - B)} ${adjustedY(backLeftFlap.top + B)}
    L ${adjustedX(leftOutsideWall.left - B)} ${adjustedY(leftOutsideWall.top - B)}
    L ${adjustedX(outsideFrontWall.left - B)} ${adjustedY(leftOutsideWall.top - B)}
    L ${adjustedX(outsideFrontWall.left - B)} ${adjustedY(overlap.top + overlap.height)}
    L ${adjustedX(overlap.left + 2*MT - B)} ${adjustedY(overlap.top)}
    L ${adjustedX(overlap.left + 2*MT - B)} ${adjustedY(overlap.top - B)}
    Z
  `
  return d
}

function getOutlineWithoutNonPrintPanels(box, isNormalized = false, printSide = 'outside') {
  const def = printSide === 'outside'
    ? createPathDefinitionForOutlineWithoutNonPrintPanels(box, isNormalized)
    : createPathDefinitionForOutlineWithoutNonPrintPanelsForInsidePrint(box, isNormalized)

  const transformStyle = printSide === 'outside' ? '' : `transform: scaleX(-1); transform-origin: center;`

  const path = `
    <path
      style="${transformStyle}"
      stroke="green"
      fill="#000000"
      d="${def}" />
  `
  return path
}

function createOutlinePathDefinition(box) {
  const documentWidth = box.canvasWidth
  const documentHeight = box.canvasHeight

  const B = box.bleedInPx
  const MT = box.materialThicknessInPx
  const W = box.widthInPx
  const L = box.lengthInPx
  const D = box.depthInPx
  const OW = box.overlapWidthInPx
  const FW = box.flapWidthInPx
  const COW = box.cutOutWidthInPx

  const panels = box.panels.map(panel => ({
    ...panel,
    left: panel.left * PPI,
    top: panel.top * PPI,
    width: panel.width * PPI,
    height: panel.height * PPI
  }))

  const frontRightFlap = panels.find(panel => panel.name === "frontRightFlap")

  const rightClosingFlap = panels.find(panel => panel.name === "rightClosingFlap")
  rightClosingFlap.point7.x *= PPI
  rightClosingFlap.point7.y *= PPI

  const leftClosingFlap = panels.find(panel => panel.name === "leftClosingFlap")
  leftClosingFlap.point3.x *= PPI
  leftClosingFlap.point3.y *= PPI

  const frontClosingFlap = panels.find(panel => panel.name === "frontClosingFlap")
  frontClosingFlap.point5.x *= PPI
  frontClosingFlap.point5.y *= PPI
  frontClosingFlap.point12.x *= PPI
  frontClosingFlap.point12.y *= PPI

  const d = `
    M ${B} ${B}
    L ${frontRightFlap.left + frontRightFlap.width} ${B}
    L ${frontRightFlap.left + frontRightFlap.width} ${rightClosingFlap.top}
    L ${frontRightFlap.left + frontRightFlap.width} ${rightClosingFlap.top + 0.25*rightClosingFlap.height}
    L ${frontRightFlap.left + frontRightFlap.width - COW} ${rightClosingFlap.top + 0.25*rightClosingFlap.height}
    L ${frontRightFlap.left + frontRightFlap.width - COW} ${rightClosingFlap.top + 0.75*rightClosingFlap.height}
    L ${frontRightFlap.left + frontRightFlap.width} ${rightClosingFlap.top + 0.75*rightClosingFlap.height}
    L ${rightClosingFlap.point7.x + (1 * PPI)} ${rightClosingFlap.point7.y - (1 * PPI)}
    Q ${rightClosingFlap.point7.x + (1 * PPI)} ${rightClosingFlap.point7.y - (0.25 * PPI)} ${rightClosingFlap.point7.x} ${rightClosingFlap.point7.y}
    L ${rightClosingFlap.left} ${rightClosingFlap.top + rightClosingFlap.height}
    L ${frontClosingFlap.point5.x} ${frontClosingFlap.point5.y}
    Q ${frontClosingFlap.point5.x - (0.25 * PPI)} ${frontClosingFlap.point5.y + (1 * PPI)} ${frontClosingFlap.point5.x - (1 * PPI)} ${frontClosingFlap.point5.y + (1 * PPI)}
    L ${frontClosingFlap.left + 0.75*frontClosingFlap.width} ${frontClosingFlap.point5.y + (1 * PPI)}
    L ${frontClosingFlap.left + 0.75*frontClosingFlap.width} ${frontClosingFlap.point5.y + (1 * PPI) - COW}
    L ${frontClosingFlap.left + 0.25*frontClosingFlap.width} ${frontClosingFlap.point5.y + (1 * PPI) - COW}
    L ${frontClosingFlap.left + 0.25*frontClosingFlap.width} ${frontClosingFlap.point5.y + (1 * PPI)}
    L ${frontClosingFlap.point12.x + (1 * PPI)} ${frontClosingFlap.point12.y + (1 * PPI)}
    Q ${frontClosingFlap.point12.x + (0.25 * PPI)} ${frontClosingFlap.point12.y + (1 * PPI)} ${frontClosingFlap.point12.x} ${frontClosingFlap.point12.y}
    L ${frontClosingFlap.left} ${frontClosingFlap.top}
    L ${leftClosingFlap.point3.x} ${leftClosingFlap.point3.y}
    Q ${leftClosingFlap.point3.x - (1 * PPI)} ${leftClosingFlap.point3.y - (0.25 * PPI)} ${leftClosingFlap.point3.x - (1 * PPI)} ${leftClosingFlap.point3.y - (1 * PPI)}
    L ${leftClosingFlap.left} ${leftClosingFlap.top + 0.75*leftClosingFlap.height}
    L ${leftClosingFlap.left + COW} ${leftClosingFlap.top + 0.75*leftClosingFlap.height}
    L ${leftClosingFlap.left + COW} ${leftClosingFlap.top + 0.25*leftClosingFlap.height}
    L ${leftClosingFlap.left} ${leftClosingFlap.top + 0.25*leftClosingFlap.height}
    L ${B} ${B}

  `

  return d
}

function getOutline(box, printSide = 'outside') {
  const transformElement = printSide === 'inside'
    ? `transform: scaleX(-1); transform-origin: center;`
    : ''
  const path = `
    <path
      style="${transformElement}"
      stroke="blue"
      fill="none"
      d="${createOutlinePathDefinition(box)}" />
  `

  return path
}

function createCutlinesPathDefinition(box) {
  const MT = box.materialThicknessInPx

  const panels = box.panels.map(panel => ({
    ...panel,
    left: panel.left * PPI,
    top: panel.top * PPI,
    width: panel.width * PPI,
    height: panel.height * PPI
  }))

  const insideFrontWall = panels.find(panel => panel.name === "insideFrontWall")
  const overlap = panels.find(panel => panel.name === "overlap")
  const outsideFrontWall = panels.find(panel => panel.name === "outsideFrontWall")
  const bottom = panels.find(panel => panel.name === "bottom")
  const backWall = panels.find(panel => panel.name === "backWall")
  const top = panels.find(panel => panel.name === "top")

  const frontLeftFlap = panels.find(panel => panel.name === "frontLeftFlap")
  const frontRightFlap = panels.find(panel => panel.name === "frontRightFlap")
  const leftOutsideWall = panels.find(panel => panel.name === "leftOutsideWall")
  const rightOutsideWall = panels.find(panel => panel.name === "rightOutsideWall")
  const backLeftFlap = panels.find(panel => panel.name === "backLeftFlap")
  const backRightFlap = panels.find(panel => panel.name === "backRightFlap")

  // Red part of foldlines
  const redArea = `
    M ${frontLeftFlap.left} ${frontLeftFlap.top + frontLeftFlap.height}
    L ${frontLeftFlap.left + frontLeftFlap.width - MT} ${frontLeftFlap.top + frontLeftFlap.height}
    M ${insideFrontWall.left} ${insideFrontWall.top + insideFrontWall.height}
    L ${insideFrontWall.left + insideFrontWall.width} ${insideFrontWall.top + insideFrontWall.height}
    M ${frontRightFlap.left + MT} ${frontRightFlap.top + frontRightFlap.height}
    L ${frontRightFlap.left + frontRightFlap.width} ${frontRightFlap.top + frontRightFlap.height}
    M ${overlap.left} ${overlap.top + overlap.height}
    L ${overlap.left + overlap.width} ${overlap.top + overlap.height}
    M ${outsideFrontWall.left} ${outsideFrontWall.top + outsideFrontWall.height}
    L ${outsideFrontWall.left + outsideFrontWall.width} ${outsideFrontWall.top + outsideFrontWall.height}
    M ${bottom.left} ${bottom.top + bottom.height}
    L ${bottom.left + bottom.width} ${bottom.top + bottom.height}
    M ${backWall.left + 2*MT} ${backWall.top + backWall.height}
    L ${backWall.left + backWall.width - 2*MT} ${backWall.top + backWall.height}
    M ${top.left} ${top.top + top.height - (0.5 * PPI)}
    L ${top.left + 0.5*top.width - (0.5 * PPI)} ${top.top + top.height - (0.5 * PPI)}
    M ${top.left + 0.5*top.width + (0.5 * PPI)} ${top.top + top.height - (0.5 * PPI)}
    L ${top.left + top.width} ${top.top + top.height - (0.5 * PPI)}
    M ${leftOutsideWall.left + leftOutsideWall.width} ${leftOutsideWall.top}
    L ${leftOutsideWall.left + leftOutsideWall.width} ${leftOutsideWall.top + leftOutsideWall.height}
    M ${rightOutsideWall.left} ${rightOutsideWall.top}
    L ${rightOutsideWall.left} ${rightOutsideWall.top + rightOutsideWall.height}
    M ${backLeftFlap.left} ${backLeftFlap.top}
    L ${backLeftFlap.left + backLeftFlap.width - MT} ${backLeftFlap.top}
    M ${backRightFlap.left + MT} ${backRightFlap.top}
    L ${backRightFlap.left + backRightFlap.width} ${backRightFlap.top}
    M ${top.left} ${top.top}
    L ${top.left} ${top.top + top.height - (0.5 * PPI)}
    M ${top.left + top.width} ${top.top}
    L ${top.left + top.width} ${top.top + top.height - (0.5 * PPI)}
  `
  // White part of foldlines
  const whiteFoldLines = `
    M ${frontLeftFlap.left} ${frontLeftFlap.top + frontLeftFlap.height}
    L ${frontLeftFlap.left + frontLeftFlap.width - MT} ${frontLeftFlap.top + frontLeftFlap.height}
    M ${insideFrontWall.left} ${insideFrontWall.top + insideFrontWall.height}
    L ${insideFrontWall.left + insideFrontWall.width} ${insideFrontWall.top + insideFrontWall.height}
    M ${frontRightFlap.left + MT} ${frontRightFlap.top + frontRightFlap.height}
    L ${frontRightFlap.left + frontRightFlap.width} ${frontRightFlap.top + frontRightFlap.height}
    M ${overlap.left} ${overlap.top + overlap.height}
    L ${overlap.left + overlap.width} ${overlap.top + overlap.height}
    M ${outsideFrontWall.left} ${outsideFrontWall.top + outsideFrontWall.height}
    L ${outsideFrontWall.left + outsideFrontWall.width} ${outsideFrontWall.top + outsideFrontWall.height}
    M ${bottom.left} ${bottom.top + bottom.height}
    L ${bottom.left + bottom.width} ${bottom.top + bottom.height}
    M ${backWall.left + 2*MT} ${backWall.top + backWall.height}
    L ${backWall.left + backWall.width - 2*MT} ${backWall.top + backWall.height}
    M ${top.left} ${top.top + top.height - (0.5 * PPI)}
    L ${top.left + 0.5*top.width - (0.5 * PPI)} ${top.top + top.height - (0.5 * PPI)}
    M ${top.left + 0.5*top.width + (0.5 * PPI)} ${top.top + top.height - (0.5 * PPI)}
    L ${top.left + top.width} ${top.top + top.height - (0.5 * PPI)}
    M ${leftOutsideWall.left + leftOutsideWall.width} ${leftOutsideWall.top}
    L ${leftOutsideWall.left + leftOutsideWall.width} ${leftOutsideWall.top + leftOutsideWall.height}
    M ${rightOutsideWall.left} ${rightOutsideWall.top}
    L ${rightOutsideWall.left} ${rightOutsideWall.top + rightOutsideWall.height}
    M ${backLeftFlap.left} ${backLeftFlap.top}
    L ${backLeftFlap.left + backLeftFlap.width - MT} ${backLeftFlap.top}
    M ${backRightFlap.left + MT} ${backRightFlap.top}
    L ${backRightFlap.left + backRightFlap.width} ${backRightFlap.top}
    M ${top.left} ${top.top}
    L ${top.left} ${top.top + top.height - (0.5 * PPI)}
    M ${top.left + top.width} ${top.top}
    L ${top.left + top.width} ${top.top + top.height - (0.5 * PPI)}
  `
  // Blue part of foldlines
  const blueLines = `
    M ${frontLeftFlap.left + frontLeftFlap.width} ${frontLeftFlap.top}
    L ${insideFrontWall.left} ${insideFrontWall.top + insideFrontWall.height}
    L ${overlap.left} ${overlap.top + overlap.height}
    L ${outsideFrontWall.left} ${outsideFrontWall.top + outsideFrontWall.height}
    l ${MT} ${2*MT}

    M ${frontRightFlap.left} ${frontRightFlap.top}
    L ${insideFrontWall.left + insideFrontWall.width} ${insideFrontWall.top + insideFrontWall.height}
    L ${overlap.left + overlap.width} ${overlap.top + overlap.height}
    L ${outsideFrontWall.left + outsideFrontWall.width} ${outsideFrontWall.top + outsideFrontWall.height}
    l ${-MT} ${2*MT}

    M ${backLeftFlap.left + backLeftFlap.width - MT} ${backLeftFlap.top}
    l ${-MT} ${2*MT}
    v ${backLeftFlap.height - 6*MT}
    l ${2*MT} ${2*MT}
    v ${2*MT}
    L ${backLeftFlap.left} ${backLeftFlap.top + backLeftFlap.height}

    M ${backRightFlap.left + MT} ${backRightFlap.top}
    l ${MT} ${2*MT}
    v ${backRightFlap.height - 6*MT}
    l ${-2*MT} ${2*MT}
    v ${2*MT}
    L ${backRightFlap.left + backRightFlap.width} ${backRightFlap.top + backRightFlap.height}

    M ${top.left + 0.5*top.width - (0.5 * PPI)} ${top.top + top.height - (0.5 * PPI)}
    Q ${top.left + 0.5*top.width - (0.5 * PPI)} ${top.top + top.height} ${top.left + 0.5*top.width} ${top.top + top.height}
    Q ${top.left + 0.5*top.width + (0.5 * PPI)} ${top.top + top.height} ${top.left + 0.5*top.width + (0.5 * PPI)} ${top.top + top.height - (0.5 * PPI)}
  `
  return {
    redArea,
    whiteFoldLines,
    blueLines
  }
}

function getCutlines(box, printSide = 'outside') {
  const {
    redArea,
    whiteFoldLines,
    blueLines
  } = createCutlinesPathDefinition(box)

  const transformElement = printSide === 'inside'
    ? `transform: scaleX(-1); transform-origin: center;`
    : ''

  // Red part of foldlines
  // style="${transformElement}"
  let path = `
    <path
      stroke="red"
      fill="none"
      stroke-dasharray="10 10"
      d="${redArea}" />
  `

  // White part of foldlines
  // style="${transformElement}"
  path += `
    <path
      stroke="white"
      fill="none"
      stroke-dasharray="10 10"
      stroke-dashoffset="10"
      d="${whiteFoldLines}" />
  `

  // style="${transformElement}"
  path += `
    <path
      stroke="blue"
      fill="none"
      d="${blueLines}" />
  `
  return path
}

export {
  getSvgForGeom,
  get2DEditorSvg,
  getOutlineWithBleed,
  getOutlineWithoutNonPrintPanels,
  getOutline,
  getCutlines,
};
